"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BookingCalendar = void 0;
var React = require("react");
var moment = require("moment");
var react_1 = require("@fullcalendar/react");
var daygrid_1 = require("@fullcalendar/daygrid");
var timegrid_1 = require("@fullcalendar/timegrid");
var list_1 = require("@fullcalendar/list");
var interaction_1 = require("@fullcalendar/interaction");
var moment_timezone_1 = require("@fullcalendar/moment-timezone");
var config_1 = require("../../../config");
var utils_1 = require("../../../utils");
var BookingLocationService_1 = require("../../../services/BookingLocationService");
function bookingsToEvents(user, is_admin, events, locations, current_booking) {
    if (current_booking === void 0) { current_booking = undefined; }
    return events.map(function (event, event_index) {
        var start = moment(event.start, config_1.ISO_DATETIME_FORMAT);
        var end = moment(event.end, config_1.ISO_DATETIME_FORMAT);
        var location_index = (0, utils_1.findIndexById)(locations, event.resourceId);
        var location = location_index >= 0
            ? locations[location_index]
            : { id: undefined, color_index: undefined };
        return {
            id: event.id + "",
            editable: is_admin || event.visitor_user_id == user.id,
            allDay: event.allDay,
            start: start.toDate(),
            end: end.toDate(),
            title: event.title,
            backgroundColor: location.color_index
                ? BookingLocationService_1.location_colors[location.color_index]
                : BookingLocationService_1.location_colors[0],
            className: current_booking && current_booking.id == event.id
                ? "logistics-event-selected"
                : "logistics-event",
            extendedProps: {
                locationId: location.id,
                locationIndex: location_index,
            },
        };
    });
}
function canOverlapEvent(stillEvent, movingEvent) {
    return (stillEvent.extendedProps.locationId !=
        movingEvent.extendedProps.locationId);
}
var BookingCalendar = function (_a) {
    var user = _a.user, is_admin = _a.is_admin, current_booking = _a.current_booking, setCurrentBooking = _a.setCurrentBooking, bookings_data = _a.bookings_data, bookingsSvc = _a.bookingsSvc, location_data = _a.location_data;
    function changeEvent(change) {
        if (change.event.end.getDay() != change.event.start.getDay()) {
            change.revert();
            return;
        }
        console.log(change);
        var book_start = moment(change.event.start).format(config_1.ISO_DATETIME_SAVE_FORMAT);
        var book_end = moment(change.event.end).format(config_1.ISO_DATETIME_SAVE_FORMAT);
        bookingsSvc.change_booking(parseInt(change.event.id), book_start, book_end);
    }
    return (React.createElement(react_1.default, { editable: true, allDaySlot: false, firstDay: 1, height: "100%", timeZone: user ? user.timezone : "UTC", headerToolbar: {
            start: "title",
            center: "dayGridMonth timeGridWeek timeGridDay",
            end: "today prev next",
        }, plugins: [
            daygrid_1.default,
            timegrid_1.default,
            list_1.default,
            interaction_1.default,
            moment_timezone_1.default,
        ], initialView: "dayGridMonth", events: bookingsToEvents(user, is_admin, bookings_data.events, location_data, current_booking), views: {
            dayGridMonth: {
                eventTimeFormat: {
                    hour: "2-digit",
                    minute: "2-digit",
                    meridiem: false,
                    hour12: false,
                },
            },
            timeGrid: {
                eventTimeFormat: {
                    hour: "2-digit",
                    minute: "2-digit",
                    meridiem: false,
                    hour12: false,
                },
            },
        }, eventClick: function (info) {
            setCurrentBooking(parseInt(info.event.id));
        }, eventOverlap: canOverlapEvent, eventChange: changeEvent }));
};
exports.BookingCalendar = BookingCalendar;
